var _path, _path2, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Work50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC80",
    d: "M24.3,22.7c-1.1-1.1-3-1.1-4.2,0.1c-1.2,1.2-1.2,3-0.1,4.2l6.4,6.4c1.1,1.1,3,1.1,4.2-0.1c1.2-1.2,1.2-3,0.1-4.2L24.3,22.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC80",
    d: "M20.2,35.6l7.9-7.9l0.6-0.6l1.1,1.1c0.8,0.8,2.9,1.3,4.3-0.1c1.4-1.4,0.6-3.4-0.1-4.2c-0.7-0.7-3.2-3.2-3.2-3.2s1.4-4.2,1.1-6.4c-0.1-1.9-1.2-3.2-3.5-3.5l-5-0.8c-4.2,0-7.8,0.5-10.8,3.5l-4.9,4.9C4.2,22,4,27.9,7.6,31.5c0,0,3.4,3.4,7.7,7.7L20.2,35.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC80",
    d: "M20,26.9c-1.1-1.1-3-1.1-4.2,0.1c-1.2,1.2-1.2,3-0.1,4.2l5.1,5.1c1.1,1.1,3,1.1,4.2-0.1c1.2-1.2,1.2-3,0.1-4.2L20,26.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC80",
    d: "M14.5,29.9c-1.1-1.1-3-1.1-4.2,0.1c-1.2,1.2-1.2,3-0.1,4.2l5.1,5.1c1.1,1.1,3,1.1,4.2-0.1c1.2-1.2,1.2-3,0.1-4.2L14.5,29.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M9.7 33.5c-2 1.9-3.5 3.1-3.5 3.1C4.7 38.2 4.6 40.6 6 42c1.4 1.4 3.8 1.4 5.3-.1.1-.1 1.4-1.3 3.3-3.3L9.7 33.5zM9 40.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5S9.8 40.5 9 40.5zM42.5 10.5L38 15c0 0-1.7 0-3.4-1.6C33 11.7 33 10 33 10l4.6-4.6c-3.3-1-6.5-.2-8.8 2.1-3.5 3.5-.4 7.9-1.3 8.8-.2.2-.3.3-.5.5l4.2 4.2c.2-.2.4-.4.6-.6.9-.9 5.2 2.4 8.8-1.2C42.7 16.9 43.6 14.1 42.5 10.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F2A25A",
    d: "M30 28.3l-3-3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L30 28.3zM25.7 32.5l-3.2-3.1c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4L25.7 32.5zM20.2 35.5L17.8 33c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4L20.2 35.5zM27.4 16.4c.2-.2.2-.4.2-.7l-3.1-1.2 2.5 2.5C27.1 16.7 27.3 16.5 27.4 16.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Work50);
export default __webpack_public_path__ + "static/media/icons8-work-50.fff593de21bc28773d2b8ad9dd9e33b6.svg";
export { ForwardRef as ReactComponent };